import { render, staticRenderFns } from "./zoho-import-view.vue?vue&type=template&id=61b7e659"
import script from "./zoho-import-view.vue?vue&type=script&lang=js"
export * from "./zoho-import-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports